import React, { useCallback, useEffect } from 'react';
import { ButtonProps } from '@material-ui/core/Button';
import { createStyles, makeStyles } from '@material-ui/styles';
import { useFormikContext } from 'formik';
import { Theme } from '@material-ui/core';

import { Button } from '..';
import hotKeyConverter from '../../utility/keyCodeConverter';

type Props = ButtonProps & {
  withHotkey?: boolean;
  closeDialog?: () => void;
  closeOnCancel?: boolean;
};

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    '&:hover': {
      backgroundColor: palette.cancelAction.background,
    },
  },
  disabled: palette.disabledButton,
}), { name: 'submit' });

const FormReset = ({
  children,
  onClick,
  closeDialog,
  closeOnCancel = true,
  withHotkey,
  ...props
}: Props) => {
  const styles = useStyles();

  const formContext = useFormikContext();

  useEffect(() => {
    const hotKeyHandler = (event: KeyboardEvent) => {
      if (event.keyCode === hotKeyConverter('esc')) {
        event.preventDefault();
        formContext.resetForm();
        if (closeDialog) closeDialog();
      }
    };
    if (withHotkey) {
      window.addEventListener('keyup', hotKeyHandler);
    }
    return () => {
      if (withHotkey) {
        window.removeEventListener('keyup', hotKeyHandler);
      }
    };
  }, [withHotkey, formContext, closeDialog]);

  const reset = useCallback((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (onClick) {
      onClick(e);
    }

    if (!e.defaultPrevented) {
      formContext.resetForm();
      if (closeOnCancel && closeDialog) closeDialog();
    }
  }, [onClick, formContext, closeDialog, closeOnCancel]);

  return (
    <Button
      type="reset"
      onClick={reset}
      classes={{
        ...styles,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default FormReset;
